import { resourceIdZodSchema } from "@@/shared/acquire/resources/resource-id";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { checkIn_checkedInEventZodObject } from "@@/shared/statuses/reservation-check-ins/events/check-in.checked-in.event";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";

const resourceCheckInStatusProjectionZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("STATUS_PROJECTION"),
    _createdAt: isoAndUnixZodSchema,
    _version: z.number().int().positive(),
    type: z.literal("RESOURCE_CHECK_IN"),
    resourceId: resourceIdZodSchema,
    providerId: providerIdZodSchema,
    count: z.number().int().min(0),
    currentCheckIns: z.array(checkIn_checkedInEventZodObject),
});
type ResourceCheckInStatusProjection = z.infer<
    typeof resourceCheckInStatusProjectionZodObject
>;
type ResourceCheckInStatusProjectionType =
    ResourceCheckInStatusProjection["type"];

type FactoryParams = Except<
    ResourceCheckInStatusProjection,
    "_createdAt" | "_type" | "type" | "_id"
>;
const resourceCheckInStatusProjectionFactory = (
    params: FactoryParams,
): ResourceCheckInStatusProjection => {
    return {
        ...params,
        _type: "STATUS_PROJECTION",
        type: "RESOURCE_CHECK_IN",
        _createdAt: nowIsoAndUnix(),
        _id: generateId({ prefix: "status_projection__" }),
    };
};

const initialResourceCheckInStatusProjectionFactory = (
    params: Except<FactoryParams, "_version" | "count" | "currentCheckIns">,
): ResourceCheckInStatusProjection => {
    return resourceCheckInStatusProjectionFactory({
        ...params,
        _version: 0,
        count: 0,
        currentCheckIns: [],
    });
};

export {
    initialResourceCheckInStatusProjectionFactory,
    resourceCheckInStatusProjectionFactory,
    resourceCheckInStatusProjectionZodObject,
};
export type {
    ResourceCheckInStatusProjection,
    ResourceCheckInStatusProjectionType,
};
